export default __webpack_public_path__ + "static/media/cc-zero.ad1ee0ea.svg";